import React from 'react';
import TranslatedCopy from '../../intl/translated-copy';

const HeaderMenuMyTripsBenefits = () => {
  return (
    <div className='HeaderMenuBook-left-newLook'>
      <div className='HeaderMenuBook-left-newLook--inThisSection'>
        <TranslatedCopy copyID='HUB_LOOKUP_SUBTITLE' />
      </div>
      <div className='HeaderMenuBook-left-newLook--benefits'>
        <div className='HeaderMenuBook-left-newLook--benefits--icon'>
          <i className='Icon Icon--checkInBenefitIcon' />
        </div>
        <div className='HeaderMenuBook-left-newLook--benefits--text'>
          <div className='HeaderMenuBook-left-newLook--benefits--text--title'>
            <TranslatedCopy copyID='HUB_CKIN_BODYONE' />
          </div>
          <div className='HeaderMenuBook-left-newLook--benefits--text--subtitle'>
            <TranslatedCopy copyID='HUB_CKIN_BODYINFO' />
          </div>
        </div>
      </div>
      <div className='HeaderMenuBook-left-newLook--benefits'>
        <div className='HeaderMenuBook-left-newLook--benefits--icon'>
          <i className='Icon Icon--upsell_change_dates' />
        </div>
        <div className='HeaderMenuBook-left-newLook--benefits--text'>
          <div className='HeaderMenuBook-left-newLook--benefits--text--title'>
            <TranslatedCopy copyID='HUB_SR_BODYONE' />
          </div>
          <div className='HeaderMenuBook-left-newLook--benefits--text--subtitle'>
            <TranslatedCopy copyID='HUB_SR_BODYINFO' />
          </div>
        </div>
      </div>
      <div className='HeaderMenuBook-left-newLook--benefits'>
        <div className='HeaderMenuBook-left-newLook--benefits--icon'>
          <i className='Icon Icon--upsell_classic_fare' />
        </div>
        <div className='HeaderMenuBook-left-newLook--benefits--text'>
          <div className='HeaderMenuBook-left-newLook--benefits--text--title'>
            <TranslatedCopy copyID='HUB_SEATS_BODYONE' />
          </div>
        </div>
      </div>
      <div className='HeaderMenuBook-left-newLook--benefits'>
        <div className='HeaderMenuBook-left-newLook--benefits--icon'>
          <i className='Icon Icon--upsell_two_checked_bags' />
        </div>
        <div className='HeaderMenuBook-left-newLook--benefits--text'>
          <div className='HeaderMenuBook-left-newLook--benefits--text--title'>
            <TranslatedCopy copyID='HUB_BAGS_BODYONE' />
          </div>
        </div>
      </div>
      <div className='HeaderMenuBook-left-newLook--benefits'>
        <div className='HeaderMenuBook-left-newLook--benefits--icon'>
          <i className='Icon Icon--extraBenefits' />
        </div>
        <div className='HeaderMenuBook-left-newLook--benefits--text'>
          <div className='HeaderMenuBook-left-newLook--benefits--text--title'>
            <TranslatedCopy copyID='HUB_XTRAS_BODYONE' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderMenuMyTripsBenefits;